export const ANALYZE_TYPOLOGIES = 'ANALYZE_TYPOLOGIES';
export const ANALYZE_TYPOLOGIES_SUCCESS = 'ANALYZE_TYPOLOGIES_SUCCESS';
export const ANALYZE_TYPOLOGIES_FAILED = 'ANALYZE_TYPOLOGIES_FAILED';
export const RESET_TYPOLOGY_ANALYSIS = 'RESET_TYPOLOGY_ANALYSIS';

export const analyzeTypologies = (payload) => ({
  type: ANALYZE_TYPOLOGIES,
  payload
});

export const analyzeTypologiesSuccess = (payload) => ({
  type: ANALYZE_TYPOLOGIES_SUCCESS,
  payload
});

export const analyzeTypologiesFailed = (payload) => ({
  type: ANALYZE_TYPOLOGIES_FAILED,
  payload
});

export const resetTypologyAnalysis = () => ({
  type: RESET_TYPOLOGY_ANALYSIS
});
